/**
 * Navigation CTA from a plan's detail header to its week-grid view. It sits in
 * `menuPlanResource.detail.headerActions` (#1804) — navigation, like a command,
 * must not cost a tab click to find. Kept a separate component (not inline in
 * the schema) so the destination can change without touching the resource
 * definition.
 */
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { CalendarDays } from 'lucide-react';
import { Button } from '@resource-kit/ui/react';

interface Props {
  planId: string;
}

export function WeekViewLink({ planId }: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // Button doesn't support `asChild` — programmatic navigate on
  // click preserves the button's a11y semantics while pointing at
  // the route. Same pattern other detail-page CTAs in the codebase
  // use; can promote to a real `<Link>` if we add a button variant
  // that wraps `<Slot>` later.
  return (
    <Button
      size="sm"
      variant="outline"
      onClick={() => navigate(`/menu-planning/plans/${planId}/week`)}
      data-testid="menu-plan-week-open"
    >
      <CalendarDays className="mr-1 h-4 w-4" />
      {t('menu_plan.weekPage.openButton')}
    </Button>
  );
}
